// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"63":"Pokemon","299":"Pokedex","842":"MoveDex"}[chunkId] || chunkId) + "." + {"63":"e562ad0d","299":"9cdc0043","787":"b339c400","842":"2bc4558a"}[chunkId] + ".chunk.js";
};